import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Promotion.css";

const SLIDES = [
  {
    id: "hero",
    image: "/promo-hero.png",
    tag: "EXCLUSIVE OFFER",
    title: "Your card.\nMore powerful\nthan ever.",
    subtitle: "Unlock Diamond-tier benefits designed for eToro's top investors. Travel smarter, earn more, live premium.",
    cta: "See what's included",
  },
  {
    id: "lounges",
    image: "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?auto=format&fit=crop&w=800&h=700&q=85",
    tag: "TRAVEL",
    title: "1,300+ airport\nlounges worldwide.",
    subtitle: "Skip the queues. Enjoy complimentary food, drinks, showers and high-speed Wi-Fi at the world's best airports.",
    cta: "Explore lounges",
    route: "/lounges",
  },
  {
    id: "stockback",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=800&h=700&q=85",
    tag: "INVESTMENT",
    title: "Earn up to 5%\nstock-back rewards.",
    subtitle: "Every card purchase earns you real stocks automatically. Any tier, any spend — watch your portfolio grow.",
    cta: "Learn about Stock-Back",
    route: "/stock-back",
  },
  {
    id: "protection",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=800&h=700&q=85",
    tag: "PROTECTION",
    title: "Every purchase,\nautomatically protected.",
    subtitle: "90-day purchase protection, extended warranty, and travel insurance — all built into your card. No claims forms.",
    cta: "View all benefits",
    route: "/benefits",
  },
];

export default function Promotion() {
  const navigate = useNavigate();
  const [slide, setSlide] = useState(0);
  const current = SLIDES[slide];
  const isLast = slide === SLIDES.length - 1;

  function next() {
    if (isLast) {
      if (current.route) navigate(current.route);
      else navigate("/");
    } else {
      setSlide(s => s + 1);
    }
  }

  function skip() { navigate("/"); }

  return (
    <div className="promo-screen">
      {/* Full-bleed image */}
      <div className="promo-img-wrap">
        <img
        src={current.image}
        alt=""
        className={`promo-img${current.id === "stockback" ? " promo-img-flipped" : ""}`}
      />
        <div className="promo-img-fade" />
      </div>

      {/* Top bar */}
      <div className="promo-top-bar">
        <div className="promo-dots">
          {SLIDES.map((_, i) => (
            <button key={i} className={`promo-dot ${i === slide ? "active" : ""}`} onClick={() => setSlide(i)} type="button" />
          ))}
        </div>
        <button className="promo-skip" type="button" onClick={skip}>Skip</button>
      </div>

      {/* Content */}
      <div className="promo-content">
        <span className="promo-tag">{current.tag}</span>
        <h1 className="promo-title">{current.title}</h1>
        <p className="promo-subtitle">{current.subtitle}</p>

        <button className="promo-cta" type="button" onClick={next}>
          {isLast ? current.cta : "Next"}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
